<script setup>
import { computed, ref, watch } from "vue";
import { useSertStore } from '@/stores/sertStore';
import { useValidation } from '@/utils/useValidataion';

const storeSert = useSertStore();

const value = ref(null);

const { validation, isValid, isTouched, textError } = useValidation(value);

const props = defineProps({
	type: {
		type: String,
		default: "text",
	},
	stateKey: {
		type: String,
	},
	placeholder: {
		type: String,
		default: "",
	},
	required: {
		type: Boolean,
		default: false,
	},
	responseError: {
		type: Object,
		default: () => ({ active: false, text: "" }),
	},
});

watch(
	() => storeSert.checkedItems[props.stateKey]?.title,
	(newVal) => {
        
		if (newVal !== value.value) {
			value.value = newVal ?? "";
		}
	},
	{ immediate: true }
);

function onInput(e) {
	const val = e.target.value;
	value.value = val;
	if (props.stateKey) {
		storeSert.updateCheckedItem(props.stateKey, "title", val);
	}
	validationInput(props.stateKey);
}

const validationInput = (stateKey) => {
	props.required ? validation(stateKey) : null;
};

const maxDate = computed(() => {
	const now = new Date();
	const maxYear = now.getFullYear() + 100;
	return `${maxYear}-12-31`;
});
</script>
<template>
	<label :class="['input']">
		<div class="input__holder">
			<span class="input__title"><slot></slot></span>
			<input
				:type="type"
				:placeholder="placeholder"
				:required="required"
				:class="['input__field', isTouched && (isValid ? 'valid' : 'not-valid')]"
				@input="onInput"
				@blur="validationInput(stateKey)"
				v-model="value"
				:max="type === 'date' ? maxDate : null"
			/>
		</div>
		<Transition mode="out-in">
			<span v-if="!!textError" class="input__error">{{ textError }}</span>
		</Transition>
	</label>
</template>
<style lang='scss' scoped>
.v-enter-active,
.v-leave-active {
    transition: all 0.25s ease-out;
}

.v-enter-from{
    opacity: 0;
  transform: translateX(20px);
}
.v-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}

</style>